
import * as yup from "yup";

export interface IInterviewStatus {
    status: number;
    interviewer: { employeeID: number; interviewer_Name?: string | null }[];
    interview_Date: string;
    interview_Time: string;
    meeting_Type: "virtual" | "face-to-face" | "";
    meeting_Link?: string;
    interview_Result?: number;
    interviewer_body?:string;
    candidate_body?:string;
    interviewer_Subject?: string;
    candidate_Subject?: string;
    interviewer_Email_Body?: string;
    candidate_Email_Body?: string;
}

export const emptyInterviewStatus: IInterviewStatus = {
    status: 0,
    interviewer: [],
    interview_Date: "",
    interview_Time: "",
    meeting_Type: "",

}

export const statusSchema = yup.object({
    status: yup.number().required("Status is required").min(1, "Status is required"),
    interviewer: yup.array().of(
        yup.object().shape({
            employeeID: yup.number().required(),
            interviewer_Name: yup.string().nullable().notRequired(),
        })
    ).min(1, "At least one interviewer is required")
        .required("At least one interviewer is required")
        .default([]),

    interview_Date: yup.string().required("Date is required"),
    interview_Time: yup.string().required("Time is required"),
    meeting_Type: yup.mixed<"virtual" | "face-to-face">()
        .oneOf(["virtual", "face-to-face"], "Invalid meeting type")
        .required("Meeting type is required"),

    meeting_Link: yup.string().when("meeting_Type", {
        is: "virtual",
        then: (schema) =>
            schema.required("Meeting link is required").url("Enter a valid URL"),
        otherwise: (schema) => schema.optional().strip(),
    }),
    interviewer_Subject: yup.string().required("Interviewer Subject is required"),
    candidate_Subject: yup.string().required("Candidate Subject is required"),
    interviewer_Email_Body: yup.string().required("Interviewer Email Body is required"),
    candidate_Email_Body: yup.string().required("Candidate Email Body is required"),
});

